export default function HomePage() {
  return null;
}